prismanoteApp.controller('countryListController', ['$scope', '$rootScope', '$stateParams' ,'$api', 
	function($scope, $rootScope, $stateParams, $api) {

		
}]);
